// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function cardBrandV5_decode($$enum) {
  if ($$enum === "MASTERCARD" || $$enum === "DISCOVER" || $$enum === "AMERICAN_EXPRESS" || $$enum === "VISA") {
    return $$enum;
  }
  
}

function cardBrandV5_fromString(str) {
  return cardBrandV5_decode(str);
}

var Utils = {
  cardBrandV5_decode: cardBrandV5_decode,
  cardBrandV5_fromString: cardBrandV5_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCardMaskedNumber_paymentCard",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "brand",
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastFour",
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "PaymentCard",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
